import gql from 'graphql-tag';

const QUERY_SIMILARS = gql`
  query Similars($listingId: ID!, $locale: String, $query: SimilarsQueryInput) {
    similars(listingId: $listingId, locale: $locale, query: $query) {
      checked
      currencyIsoCode
      firstAvailableDate
      id
      isInstantBooking
      noSecurityDeposit
      isFavorite
      mainPhotoUrl
      reviews {
        ratingAverage
      }
      title
      description
      type
      url
      features
      area
      offers {
        discountType
        discountValue
      }
      allowsPermanentContract
      numberOfBathrooms
      isBestChoice
      landlordId
      so
      photoIds
      otherPropertyPhotoIds
      displayPrice
      billsIncluded
      hasOffer
    }
  }
`;

export const getSimilarsQuery = client => (listingId, locale, query) =>
  client.query({
    query: QUERY_SIMILARS,
    variables: {
      listingId,
      locale,
      query
    }
  });

export default getSimilarsQuery;
